<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { L10n, setCulture } from "@syncfusion/ej2-base";
import { mapGetters } from "vuex";

export default {
  name: 'app',
  computed: {
    ...mapGetters({
      getLocale: 'i18n/getLocale'
    })
  },
  watch: {
    getLocale() {
      this.setSyncfusionTranslation()
    }
  },
  methods: {
    setSyncfusionTranslation() {
      const locale = this.getLocale.substring(0, 2)
      import(`./i18n/translations-syncfusion/${locale}.json`)
        .then(module => {
          setCulture(locale)
          L10n.load({
            [locale]: module[locale]
          })
        })
    }
  } 
}
</script>

